import { render, staticRenderFns } from "./TourSearch.vue?vue&type=template&id=96a6068a&"
import script from "./TourSearch.vue?vue&type=script&lang=js&"
export * from "./TourSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports